import React, { Component, useRef } from 'react';
import lookup from 'country-code-lookup';
import { Link } from 'react-router-dom';
import { getCountryCodes, getLocation, getNewUsers } from '../../fetchApi';
import { wait, delUnusedData } from '../../ulits';

import { User } from '../User';
import { Loader } from '../Loader';
import { Popup } from '../Popup';
import { Snackbar } from '../Snackbar';
import { Button } from '../Button';

import './UsersList.scss';

class UsersList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      users: this.props.storedUsers,
      isPending: true,
      isError: false,
      mapOpen: false,
      currentUserName: '',
      currentCoords: [],
    };

    this.updateCoords = this.updateCoords.bind(this);
  }

  componentDidMount() {
    const users = JSON.parse(window.localStorage.getItem('users'));
    if (!users || users.length === 0) {
      this.setState({ isError: false });
      getNewUsers()
        .then((data) => {
          const countryNames = data.results.map((user, index) => {
            data.results[index].realLocation = {};
            data.results[index].realLocation.country = user.location.country;
            return user.location.country;
          });
          const countryCodes = getCountryCodes(countryNames);

          //! delete not needed data & sort important location info
          countryCodes.forEach((code, index) => {
            delUnusedData(data, code, index);
          });

          const { results } = data;

          this.setState({
            users: results,
            isPending: false,
            isError: false,
          });
          localStorage.setItem('users', JSON.stringify(results));
        })
        .catch((err) => {
          this.setState({
            isPending: false,
            isError: true,
          });
        });
    } else {
      this.setState({
        users,
        isPending: false,
        isError: false,
      });
    }
  }

  // update cords on popup map( and display it ) when user click on a person's location
  // eslint-disable-next-line class-methods-use-this
  async updateCoords(e, id) {
    const activeUser = this.state.users.find((user) => user.login.uuid === id);
    if (!activeUser) {
      return;
    }
    const { countryCode } = activeUser.realLocation;

    // if exists - no need to fetch
    const coords =
      !activeUser.realLocation.coords ||
      (activeUser.realLocation.coords[0] === 0 &&
        activeUser.realLocation.coords[0] === 0)
        ? await getLocation(countryCode)
        : activeUser.realLocation.coords;

    // if doesn't exist fetch and save coords in state and in localstorage
    // save to state
    const currentUsersState = this.state.users;
    const currentIndex = currentUsersState.indexOf(activeUser);
    currentUsersState[currentIndex].realLocation.coords = coords;
    this.setState((prevState) => ({ users: currentUsersState }));

    // save to localstorage
    window.localStorage.setItem('users', JSON.stringify(currentUsersState));

    // display map popup with recently clicked user's location
    this.setState((prevState) => ({
      mapOpen: true,
      currentCoords: coords,
      currentUserName: `${activeUser.name.first} ${activeUser.name.last}`,
    }));
  }

  closeMap(e) {
    if (!e.target.classList.contains('popup-overlay')) {
      return;
    }
    this.setState((prev) => ({ mapOpen: false }));
  }

  render() {
    return (
      <div className="users">
        {this.state.isPending ? <Loader msg="Loading" /> : ''}

        {this.state.users && this.state.users.length > 0
          ? this.state.users.map((user) => (
              <User
                key={user.login.uuid}
                id={user.login.uuid}
                name={user.name.first}
                surname={user.name.last}
                gender={user.gender}
                age={user.dob.age}
                country={user.location.country}
                email={user.email}
                imgSrc={user.picture.large}
                updateCoords={this.updateCoords}
              />
            ))
          : ''}

        {this.state.isPending ? (
          ''
        ) : (
          <Link to="./addNew">
            <Button>Add User</Button>
          </Link>
        )}

        {this.state.mapOpen && this.state.currentCoords.length > 0 ? (
          <Popup
            role="tooltip"
            closeMap={(e) => this.closeMap(e)}
            currentCoords={this.state.currentCoords}
          >
            Location of {this.state.currentUserName}
          </Popup>
        ) : (
          ''
        )}
        {this.props.snackbar.visible && (
          <Snackbar
            type={this.props.snackbar.type}
            msg={this.props.snackbar.msg}
          />
        )}
      </div>
    );
  }
}

export default UsersList;
